export function initVideoSliderReviews(){
    const containers = document.querySelectorAll<HTMLDivElement>(".video-container");

    if (!containers.length) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const container = entry.target as HTMLDivElement;

                // Если видео ещё не создано → создаём
                if (!container.querySelector("video")) {
                    const video = document.createElement("video");

                    // Безопасно читаем data-атрибуты
                    const src = container.dataset.src;
                    const poster = container.dataset.poster;

                    if (src) video.src = src;
                    if (poster) video.poster = poster;

                    video.muted = true;
                    video.loop = true;
                    video.autoplay = true;
                    video.playsInline = true; // для iPhone
                    video.preload = "auto";
                    video.className = "why-slide__video";

                    container.appendChild(video);

                    // Без ошибок при невозможности воспроизвести
                    video.play().catch(() => {});
                }
            }
        });
    }, { threshold: 0.6 });

    containers.forEach((c) => observer.observe(c));
}